import { FiArrowRightCircle } from 'react-icons/fi';
import CardH from 'src/components/cards/card-h';

const SectionH = ({ data, heading, count = 4, large = false, description = false, path = '#', more = true, eventDataLayer }) => {
  return (
    <div className='block-wrapper'>
      <div className='block-title'>
        <h2>{heading}</h2>
        {more && (
          <a href={path} className='more'>
            ดูทั้งหมด <FiArrowRightCircle />
          </a>
        )}
      </div>
      <div className={`row block-content ${!large ? '--small' : ''}`}>
        {data.slice(0, count).map((item, index) => (
          <div key={index} className='col-12 block-item'>
            <CardH
              data={item}
              description={description}
              large={large}
              heading={heading}
              //! DATALAYER
              eventDataLayer={{
                ...eventDataLayer,
                data: {
                  ...eventDataLayer?.data,
                  title: item?.title,
                  index: index + 1
                }
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionH;
